<template>
  <div class="info-page">
    <!-- 仅原来的 section 3 内容 -->
    <div v-wechat-title="'新春开局，胜天半子'"></div>
    <!-- 登录弹窗 -->
    <Login
      v-if="isShowLogin"
      v-on:channelCallback="selectCallback"
      :gameName="gameName"
      :downloadUrl="downloadUrl"
      :loginTypes="loginTypes"
      channelTips="角色UID可在游戏中—设置—UID查看"
      :autoOpenOS="true"
      @loginSuccess="loginSuccess"
      @selectCallback="loginCallback"
      noAuthLogin
    ></Login>
    <Os
      v-if="isShowOs"
      v-on:selectCallback="selectCallback"
      v-on:logoutCallback="osCancell"
      @noRole="noRole"
      @getSelectInfo="getSelectInfo"
      :gameName="gameName"
    ></Os>
    <!-- 头部 -->
    <Header
      v-if="true"
      :config="headerConfig"
      :isShowInfo="true"
      :isOnline="1"
      :downloadApp="downloadApp"
    />
    <div class="content-box">
      <div class="banner"></div>
      <div class="banner-box" />
      <div class="yyhd1">
        <div class="yyhd1_main">
          <div class="btn" @click="gotoActive1"></div>
        </div>
        <div class="triangle"></div>
      </div>
      <div class="yyhd2">
        <div class="yyhd2_main">
          <div class="btn" @click="gotoActive2"></div>
        </div>
        <div class="triangle"></div>
      </div>
      <div class="yyhd3">
        <div class="yyhd3_main">
          <div class="btn" @click="gotoActive3"></div>
        </div>
        <div class="triangle"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../Header";
import { mapState, mapMutations, mapActions } from "vuex";
import { Toast, Indicator } from "mint-ui";
import { headerConfig } from "../headerConfig";
import Os from "../os";
import Login from "@/components/login";
import { getRandomString } from "@/utils/utils";
import { onGetInitDataAPI, onGetTimeAPI } from "../api";

export default {
  name: "RecallInfo",
  components: {
    Header,
    Login,
    Os,
  },
  props: {
    downloadApp: {
      type: Function,
      default: () => {
        return () => {};
      },
    },
    logger: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      headerConfig,
      gameName: "snail",
      downloadUrl: "http://snail.qingcigame.com/official/",
      loginTypes: ["sms", "password"],
    };
  },
  created() {},
  watch: {
    logger: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.logger.sum("马年专题_运营活动页");
        }
      },
    },
  },
  mounted() {
    this.setShare({
      link: `https://h5.qingcigame.com/snail/springFestival/anniversary${getRandomString()}`,
      title: "【最强蜗牛】蜗也要胜天半子！",
      imgUrl:
        "https://download4.qcplay.com/qcgame-api/mDG0FvkV2xtEH4cfyEIt8MMcWF6CxRo6IdrDiHzx.png",
      desc: "组队闯天局，限定绿贵轻松到手，搜寻Beter前世“马必得”的秘密宝库，入队速戳！",
    });
    this.getLoginContainer();
  },
  computed: {
    ...mapState(["userInfo", "activeInfo", "isShowLogin", "isShowOs"]),
  },
  methods: {
    // 初始化
    getLoginContainer() {
      onGetInitDataAPI().then((response) => {
        this.onInitDataCallback({ response, needAccount: false });
        this.setUserInfo(response.data.user_info);
        if (response.code == 403) {
          this.setUserInfo({});
        }
        if (response.code != 200) {
          this.onToast(response.message);
        }
        this.setActiveInfo(response.data.activity);
      });
    },
    gotoActive1() {
      this.logger.sum("马年专题_行走三界1号banner");
      window.location.href =
        "https://www.bilibili.com/bangumi/play/ss126313?spm_id_from=333.337.0.0";
    },
    gotoActive2() {
      this.logger.sum("马年专题_行走三界2号banner");
      const time = new Date().getTime();
      const kaiqi = new Date("2026/02/13 10:00:00").getTime();
      console.log(time, "time", kaiqi);
      if (time >= kaiqi) {
        window.location.href =
          "https://l.taptap.cn/hEdLY7yM?channel=rep-rep_vk9tzbdcy7z";
      } else {
        this.onToast("2月13日 10:00活动开启");
      }
    },
    gotoActive3() {
      this.logger.sum("马年专题_行走三界3号banner");
      const time = new Date().getTime();
      const kaiqi = new Date("2026/02/19 10:00:00").getTime();
      console.log(time, "time", kaiqi);
      if (time >= kaiqi) {
        window.location.href =
          "https://l.taptap.cn/0muLGAVR?channel=rep-rep_eznxbrmmtgj";
      } else {
        this.onToast("2月19日 10:00活动开启");
      }
    },
    onToast(config, duration) {
      const curConfig = {
        duration: duration || 1000,
        className: "toasts",
      };
      if (!config) {
        console.error("缺少config参数");
        return false;
      }
      if (typeof config === "string") {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    selectCallback() {},
    loginSuccess() {
      console.log("登录成功");
    },
    loginCallback(response) {
      localStorage.setItem("mnzt_token", response.data.access_token);
    },
    osCancell() {
      console.log("osCancell");
    },
    noRole() {
      this.setUserInfo({});
      // this.changeOsPopup(false);
    },
    getSelectInfo() {
      this.getLoginContainer();
      console.log("getSelectInfo");
    },
    logoutCallback() {
      console.log("logoutCallback");
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup",
      "setActiveInfo",
    ]),
    ...mapActions(["onInitDataCallback", "setShare"]),
  },
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/snail/springFestival/info/index.vue